import React from 'react';
import PropTypes from 'prop-types';
import { SuiNotificationBase } from '@splashthat/sui';
import styled from 'styled-components';

import { subheadlineLargeFontSize } from 'common/styles/typography';
import { colorWhite } from 'common/styles/palette';
import UnpublishedIcon from './unpublished.svg';

const LEARN_MORE_URL =
    'https://support.splashthat.com/hc/en-us/articles/360038148571-How-do-I-keep-an-event-unpublished-until-it-s-ready-to-go-live-Beta-';

const RightSectionContainer = styled.div`
    display: flex;
    font-size: ${subheadlineLargeFontSize};
`;

const MoreInfo = styled.a`
    cursor: pointer;
    margin-left: 1rem;
    color: ${colorWhite};
    outline: none;
`;

const UnpublishedNotification = (props) => (
    <SuiNotificationBase
        active={props.active}
        leftSection={<UnpublishedIcon style={{ width: '2.5rem' }} />}
        messageSection={<p>This event page is unpublished and only you can access it.</p>}
        rightSection={
            <RightSectionContainer style={{ display: 'flex' }}>
                <p onClick={props.onClose}>Dismiss</p>
                <MoreInfo href={LEARN_MORE_URL} target="_blank">
                    Learn more
                </MoreInfo>
            </RightSectionContainer>
        }
    />
);

UnpublishedNotification.propTypes = {
    active: PropTypes.bool,
    onClose: PropTypes.func,
};

UnpublishedNotification.defaultProps = {
    active: false,
    onClose: null,
};

export default UnpublishedNotification;
